<template>
  <div
    :class="'container ' + classString + (interactive ? ' interactive' : '')"
  >
    <div class="fullscreen" @click="toggleFullScreen" v-if="width > 700 && interactive">
      <img src="@/assets/fullscreen.svg" />
    </div>
    <Menu
      v-if="interactive"
      :variables="variables"
      :currentVariable="currentVariable"
      :headers="headers"
      @click="(v) => (currentVariable = v)"
      :width="width"
    />
    <MglMap
      :class="'map-test ' + classString"
      :zoom="zoom"
      :center="center"
      accessToken="pk.eyJ1IjoiYmVsbGluZ2NhdC1tYXBib3giLCJhIjoiY2tleW0wbWliMDA1cTJ5bzdkbTRraHgwZSJ9.GJQkjPzj8554VhR5SPsfJg"
      :mapStyle="'mapbox://styles/bellingcat-mapbox/ckf1tio9k4lcn19pk5laeovrk'"
      @click="togglehover"
    >
      <MglNavigationControl position="top-right" v-if="interactive" />
      <MglVectorLayer
        :source="{
          url: sourceURL,
          type: 'vector',
          promoteId: featureId,
        }"
        before="water"
        layerId="choropleth-fill"
        sourceId="ppp"
        :layer="layerStyle"
        @mousemove="mousemove"
        @mouseleave="mouseleave"
      />
      <MglVectorLayer
        :source="{ url: sourceURL, type: 'vector' }"
        before="water"
        layerId="choropleth-stroke"
        sourceId="ppp"
        :layer="strokeStyle"
      />
      <MglVectorLayer
        :source="{
          url: sourceURL,
          type: 'vector',
          promoteId: featureId,
        }"
        v-if="hoverFeature"
        layerId="choropleth-highlight"
        sourceId="ppp"
        :layer="{
          type: 'line',
          'source-layer': sourceLayer,
          paint: {
            'line-color': [
              'case',
              ['boolean', ['feature-state', 'hover'], false],
              'black',
              'rgba(0,0,0,0)',
            ],
            'line-width': 1,
          },
        }"
      />
    </MglMap>

    <div
      v-if="!hideLegend"
      :class="{ legend: true, w1: true, [legendStyle]: true, interactive }"
    >
      <div class="title">{{ currentTitle }}</div>
      <div class="description" v-if="interactive && currentDescription">
        {{ currentDescription }}
      </div>
      <div class="legend-row" v-for="(l, i) in legend" :key="'legend' + i">
        <div class="color" :style="{ backgroundColor: scheme(1 - i * 0.14) }" />
        <div class="label"><span class="ell">…</span>{{ l }}</div>
      </div>
    </div>

    <div
      v-if="interactive && hoverFeature && !hovering"
      class="info p-no-leading"
      @click="hovering = true"
    >
      <div class="share">
        <div class="zip">{{ hoverFeature.properties[featureId] }}</div>
        <div v-for="(sublist, i) in variables" :key="'sublist_zcta' + i">
          <div
            class="zip_row"
            v-for="v in sublist.filter(
              (v) => v.js(hoverFeature.properties) >= 0
            )"
            :key="v.key"
          >
            <div class="title">{{ v.display }}</div>
            <div class="value">
              {{
                (v.scale === currency ? currency : "") +
                  numberWithCommas(
                    Math.round(v.js(hoverFeature.properties) * v.multiplier)
                  ) +
                  (v.scale !== currency ? v.scale : "")
              }}
            </div>
          </div>
        </div>
        <!-- <div class="w2">
          <div class="zip" v-if="hoveredLoans">
            {{ hoveredLoans.length }} large loans
          </div>
          <div
            class="zip_row"
            v-for="(loan, i) in hoveredLoans"
            :key="loan.BusinessName + i"
          >
            <div class="title">{{ loan.BusinessName }}</div>
            <div class="value">
              {{ loan.LoanRange.slice(2) }}
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { MglMap, MglVectorLayer, MglNavigationControl } from "vue-mapbox";
import Menu from "@/components/Menu.vue";
import * as d3 from "d3";
import bigLoans from "../assets/loan-zips.json";

export default {
  name: "Map",
  components: {
    MglMap,
    MglVectorLayer,
    MglNavigationControl,
    Menu,
  },
  props: {
    center: Array,
    zoom: Number,
    classString: String,
    variable: String,
    title: String,
    legendStyle: String,
    hideLegend: Boolean,
    interactive: Boolean,
    sourceLayer: String,
    sourceURL: String,
    currency: String,
    ranges: Object,
    interactiveVariables: Array,
    featureId: String,
    zoomStart: Number,
  },
  data() {
    return {
      scale: [0, 0.33, 0.4, 0.46, 0.54, 0.64, 2.25],
      currentVariable: this.variable,
      strokeStyle: {
        type: "line",
        "source-layer": this.sourceLayer,
        paint: {
          "line-color": "#888",
          "line-width": [
            "interpolate",
            ["linear"],
            ["zoom"],
            this.zoomStart,
            0,
            this.zoomStart + 2,
            0.75,
          ],
        },
      },
      hoverFeature: null,
      hoveredStateId: false,
      hovering: true,
      width: 725,
    };
  },
  mounted() {
    this.width = window.innerWidth;
    window.onresize = () => {
      this.width = window.innerWidth;
    };
  },
  methods: {
    numberWithCommas(x) {
      return Math.round(x)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    togglehover() {
      this.hovering = !this.hovering;
    },
    mousemove(e) {
      if (!this.hovering) return;

      if (e.mapboxEvent.features.length > 0) {
        if (this.hoveredStateId) {
          e.map.setFeatureState(
            {
              source: "ppp",
              id: this.hoveredStateId,
              sourceLayer: this.sourceLayer,
            },
            { hover: false }
          );
        }

        this.hoveredStateId = e.mapboxEvent.features[0].id;
        e.map.setFeatureState(
          {
            source: "ppp",
            id: this.hoveredStateId,
            sourceLayer: this.sourceLayer,
          },
          { hover: true }
        );
        this.hoverFeature = e.mapboxEvent.features[0];
      } else {
        this.hoveredStateId = false;
        this.hoverFeature = null;
      }
    },
    mouseleave(e) {
      if (!this.hovering) return;

      e.map.setFeatureState(
        {
          source: "ppp",
          id: this.hoveredStateId,
          sourceLayer: this.sourceLayer,
        },
        { hover: false }
      );
      this.hoveredStateId = false;
      this.hoverFeature = null;
    },
    toggleFullScreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    },
  },
  computed: {
    variables() {
      console.log(this.interactiveVariables);
      return this.interactiveVariables
        .slice(1)
        .map((list) => list.map((v) => ({ ...this.ranges[v], key: v })));
    },
    headers() {
      return this.interactiveVariables ? this.interactiveVariables[0] : [];
    },
    currentTitle() {
      return this.title
        ? this.title
        : this.ranges[this.currentVariable].display;
    },
    currentDescription() {
      return this.ranges[this.currentVariable].description || false;
    },
    scheme() {
      return (v) =>
        (this.ranges[this.currentVariable].color || d3.interpolateMagma)(v);
    },
    breaks() {
      return this.ranges[this.currentVariable].breaks;
    },
    legend() {
      let scale = this.ranges[this.currentVariable].scale;
      return this.breaks
        .slice(1)
        .map(
          (b, i) =>
            (scale === this.currency ? this.currency : "") +
            this.numberWithCommas(
              this.breaks[i] * this.ranges[this.currentVariable].multiplier
            ) +
            "–" +
            this.numberWithCommas(
              b * this.ranges[this.currentVariable].multiplier
            ) +
            (scale !== this.currency ? scale : "")
        );
    },
    hoveredLoans() {
      if (!this.hoverFeature) return [];

      return bigLoans[this.hoverFeature.properties.zip];
    },
    layerStyle() {
      let d = 0.7 / (this.breaks.length - 2);

      let mapbox = this.breaks
        .slice(1, this.breaks.length - 1)
        .reduce((acc, cur, i) => [...acc, cur, this.scheme(1 - (i + 1) * d)], [
          this.scheme(1),
        ]);

      // mapbox.push("rgba(0,0,0,0)")

      return {
        type: "fill",
        "source-layer": this.sourceLayer,
        filter: this.ranges[this.currentVariable].filter || true,
        paint: {
          "fill-color": [
            "case",
            [">=", this.ranges[this.currentVariable].mapbox, 0],
            ["step", this.ranges[this.currentVariable].mapbox, ...mapbox],
            "rgba(0,0,0,0)",
          ],
        },
      };
    },
  },
};
</script>

<style lang="scss">
@import "@/constants/_style.scss";

.map-test {
  box-sizing: content-box;
  height: 100%;
  //   opacity: 0.5;

  // * {
  //   pointer-events: none;
  // }
}
</style>

<style lang="scss" scoped>
@import "plumber-sass/_plumber.scss";
@import "@/constants/_style.scss";

.container {
  position: relative;
  margin-bottom: $grid;
  height: calc(#{$grid} * 36);
  pointer-events: none;

  &.interactive {
    pointer-events: all;
    height: 100vh;
    width: 100vw;
  }

  &.below {
    margin-bottom: calc(
      1 * (#{$gutter-width} * 2 + #{$block-width} * 1) * #{$grid}
    );
  }
}

.color {
  width: $grid;
  height: $grid;
  //   margin-right: $grid;
  border: 1px solid #888;
}

.legend {
  position: absolute;
  bottom: calc(#{$gutter-width} * #{$grid});
  left: 0px;

  // &.left {
  //   left: calc(-1 * (#{$gutter-width} + #{$block-width}) * #{$grid});
  //   bottom: 0px;
  // }

  &.left {
    left: 0px;
    right: unset;
    bottom: calc(#{$gutter-width} * #{$grid} * 2);
  }

  &.large {
    font-size: 18px;
    width: 150px;
  }

  &.right {
    right: calc(#{$gutter-width} * #{$grid});
    left: unset;
    bottom: calc(#{$gutter-width} * #{$grid});
  }

  &.below {
    position: absolute;
    top: calc(1 * (#{$gutter-width} * 1 + #{$block-width} * 2) * #{$grid});
    padding-top: 8px;
  }

  &.france {
    position: absolute;
    top: 200px;
    height: 130px;
    background-color: white;

    &.wide {
      width: 300px;
      // margin-left: -50px;
      top: 200px;
    }

    &.inset {
      top: 290px;
    }
  }

  &.interactive {
    width: auto;
    // width: calc((#{$gutter-width} * 0 + #{$block-width} * 1) * #{$grid});
    right: 0px;
    left: unset;
    bottom: 20px;
    background-color: rgba(255, 255, 255, 0.7);
    top: unset;
    padding: 8px;
    max-width: 300px;
    font-size: 14px;
  }

  .label {
    // @include plumber(
    //   $grid-height: $grid,
    //   $baseline: 0.1,
    //   $font-size: 1,
    //   $line-height: 2,
    //   $leading-top: 0,
    //   $leading-bottom: 0
    // );

    // font-family: soleil;
    font-weight: 200;
    flex-grow: 1;
  }

  .legend-row {
    display: flex;
    margin-bottom: 2px;
  }

  .title {
    // @include plumber(
    //   $grid-height: $grid,
    //   $baseline: 0.1,
    //   $font-size: 1,
    //   $line-height: 1,
    //   $leading-top: 0,
    //   $leading-bottom: 1
    // );

    margin-bottom: 6px;

    font-weight: bold;
    // font-family: soleil;
  }
}

.container.h3 .legend.below {
  top: calc(1 * (#{$gutter-width} * 2 + #{$block-width} * 3) * #{$grid});
}

.ell {
  margin-left: 2px;
  margin-right: 2px;
  color: gray;
}

.zip {
  font-weight: bold;
}

.zip_row {
  display: flex;

  .title {
    margin-right: $grid;
    font-weight: medium;
  }

  .value {
    font-weight: bold;
  }
}

.info {
  overflow-y: scroll;
  position: absolute;
  bottom: 0px;
  left: 0px;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 10000;
  width: auto;
  padding: 8px;
  font-size: 14px;
}

.descriptions {
  padding-left: 108px;
}

.description {
  font-size: 12px;
  font-style: italic;
  margin-bottom: 8px;
}

.fullscreen {
  z-index: 5000;
  position: absolute;
  width: 33px;
  height: 33px;
  background-color: white;
  border: 2px solid rgba(190, 190, 190, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  right: 8px;
  top: 104px;
  border-radius: 6px;

  img {
    width: 24px;
  }

  &:hover {
    background-color: rgb(230, 230, 230);
    cursor: pointer;
  }
}
</style>
